"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'profilePreferences';
exports.SET_PREFERENCE = exports.namespace + "/SET_PREFERENCE";
exports.CLEAR_PREFERENCES = exports.namespace + "/CLEAR_PREFERENCES";
exports.SET_SELECTED_CATEGORY_ID = exports.namespace + "/SET_SELECTED_CATEGORY_ID";
//# sourceMappingURL=constants.js.map